export default {
    locale: 'en-AU',
    dismissAlertText: 'Close'
};
